import './Sorting.css';
import React, {useEffect, useState} from 'react';

/**
 * Handles the sorting functionality in a dropdown menu.
 *
 * @param {object} props - The props object containing the necessary properties.
 * @param {array} props.options - An array of sort options.
 * @param {object} props.messages - An object containing messages for the sort options.
 * @param {function} props.onChange - The onChange method to be called when a sort option is selected.
 *
 * @returns {JSX.Element} - The sorting component.
 */
function Sorting(props) {

  //console.info('Sorting', props);
  const [opened, setOpened] = useState(false);

  /**
   * Handles the onClick event.
   * Toggles the value of "opened" state.
   *
   * @param {Event} event - The onClick event object.
   *
   * @return {void}
   */
  function onClick(event) {
    setOpened(!opened);
  }

  /**
   * Calls the onChange method with specified parameters and updates the state of the "opened" property.
   * @param {string} sort - The sort parameter to be passed to the onChange method.
   * @param {string} order - The order parameter to be passed to the onChange method.
   * @param {string} smartUrl - The smartUrl parameter to be passed to the onChange method.
   * @return {void}
   */
  function onCheck(option) {
    props.onChange(option)
    setOpened(!opened);
  }

  const sortOptions = props.hasOwnProperty('options') &&
  Array.isArray(props.options) ?
      props.options.map(option => {
        let title = props.messages &&
        props.messages.hasOwnProperty(option.label) ?
            props.messages[option.label] : option.label;

        return <li key={option.label}
                   onClick={event =>
                       (onCheck(option))
                   }
                   className={`${option.active
                       ? 'selected'
                       : ''}`}>
          {title}
        </li>;
      }) :
      <></>;

  const activeSortLabel = () => {
    let label = props.options && Array.isArray(props.options) &&
    props.options.length ?
        props.options.find(option => option.active)?.label :
        '';

    return props.messages && props.messages.hasOwnProperty(label) ?
        props.messages[label] : label;
  };

  return (
      <div id={'sorting'} style={{
        width: !props.isMobile && !props.selectedFiltersExist
            ? '100%'
            : '',
      }}>
        <div className={'panel'}>
          <span className="curent" onClick={onClick}>
            {activeSortLabel()}
          </span>
          <span className="dropdown-arrow" onClick={onClick}/>
          {
            opened && props.hasOwnProperty('options') &&
            Array.isArray(props.options) &&
            props.options.length ?
                <ul className={'order-list'}>{sortOptions}</ul> :
                <></>
          }
        </div>
      </div>
  );
};

export default Sorting;